
// SQL selection string for consistent job data structure when fetching
// This selects the actual columns from the job_search_results table.
// Aliases like title:job_title mean the JS object will have a 'title' property.
// Columns like 'description', 'employment_type', etc., are not top-level columns
// in job_search_results table as per current schema and will be sourced from raw_data.
export const JOB_SEARCH_RESULT_FIELDS_SELECT = `
  id,
  title:job_title,
  company_name,
  location,
  job_url,
  url:job_url, 
  source,
  snippet,
  posted_date,
  raw_data, 
  created_at,
  updated_at,
  status,
  provider_id,
  query_id,
  relevance_explanation,
  score
`;

